import { createSlice, PayloadAction } from '@reduxjs/toolkit'


import { filePeview} from '../../shared/interfaces'

interface dropzoneState {
  files: Array<filePeview>,
  touched: boolean,
  hasFiles: boolean
}

const initialState: dropzoneState = {
  files:[],
  touched:false,
  hasFiles:false
}

// function freeUrls(files: Array<filePeview>) {
//   files.map(file => URL.revokeObjectURL(file.preview))
// }

const dropZoneSlice = createSlice({
  name: 'ovscSlice',
  initialState,
  reducers: {
    reset(state) {
      // freeUrls(state.files);
      state.files=[];
      state.touched=false;
      state.hasFiles=false;
    },
    setFiles(state, action: PayloadAction<Array<filePeview>>) {
      // freeUrls(state.files);
      state.files = action.payload;
      state.touched=true;
      state.hasFiles=action.payload.length>0;
    }
  }
})

export const {
  reset,
  setFiles
} = dropZoneSlice.actions

export default dropZoneSlice.reducer

